import lbiHozizontalLogo from '../assets/lbi-horizontal-logo.svg';
import iconPhone from '../assets/IconPhone.svg';
import iconLBI from '../assets/IconLBI.svg';
import iconMail from '../assets/IconMail.svg';

function Footer() {
    return (
        <div className="self-stretch px-10 py-6 bg-white rounded-2xl inline-flex flex-col justify-start items-start gap-6 w-full ">
            <div className="self-stretch inline-flex justify-start items-start gap-6">
                <div className="flex-1 inline-flex flex-col justify-center items-start gap-4">
                    <div className="self-stretch justify-center text-neutral-700 text-sm font-semibold font-['Montserrat'] leading-tight">
                        Une question ? Contactez-nous
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-1.5">
                        <div className="self-stretch p-2 rounded-lg inline-flex justify-start items-center gap-3">
                            <div data-variant="Fill" className="w-3 h-3 relative">
                                <img src={iconPhone} alt="phone icon" />
                            </div>
                            <a
                                href="tel:+33146257575"
                                className="flex-1 justify-center text-neutral-500 text-xs font-semibold font-['Montserrat'] leading-none"
                            >
                                01 46 25 75 75
                            </a>
                        </div>
                        <div className="self-stretch p-2 rounded-lg inline-flex justify-start items-center gap-3">
                            <div data-variant="Fill" className="w-3 h-3 relative">
                                <img src={iconMail} alt={'mail icon'} />
                            </div>
                            <a
                                href="mailto:support@previsite.com"
                                className="flex-1 justify-center text-neutral-500 text-xs font-semibold font-['Montserrat'] leading-none"
                            >
                                support@previsite.com
                            </a>
                        </div>
                    </div>
                </div>
                <div className="w-[1px] h-[106px] bg-neutral-200"></div>

                <div className="flex-1 inline-flex flex-col justify-center items-start gap-4">
                    <div className="self-stretch justify-center text-neutral-700 text-sm font-semibold font-['Montserrat'] leading-tight">
                        Une solution signée La Boîte Immo
                    </div>
                    <div className="self-stretch flex flex-col justify-start items-start gap-1.5">
                        <div className="self-stretch p-2 rounded-lg inline-flex justify-start items-center gap-3">
                            <div data-variant="Fill" className="w-3 h-3 relative">
                                <img src={iconLBI} alt="icon LBI" />
                            </div>
                            <a
                                href="https://www.la-boite-immo.com/la-boite"
                                target="_blank"
                                rel="noreferrer"
                                className="flex-1 justify-center text-neutral-500 text-xs font-semibold font-['Montserrat'] leading-none"
                            >
                                Qui sommes-nous ?
                            </a>
                        </div>
                        <div className="self-stretch p-2 rounded-lg inline-flex justify-start items-center gap-3">
                            <div data-variant="Fill" className="w-3 h-3 relative">
                                <img src={iconLBI} alt="icon LBI" />
                            </div>
                            <a
                                href="https://www.la-boite-immo.com/la-boite/valeurs-engagements"
                                target="_blank"
                                className="flex-1 justify-center text-neutral-500 text-xs font-semibold font-['Montserrat'] leading-none"
                                rel="noreferrer"
                            >
                                Nos valeurs & engagements
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div className="self-stretch h-0 outline outline-1 outline-offset-[-0.50px] outline-neutral-200"></div>
            <div className="self-stretch inline-flex justify-between items-center">
                <div className="justify-start">
                    <span className="text-neutral-500 text-[10px] font-normal font-['Montserrat'] leading-3">
                        © 2024 | Tous droits réservés |
                        <a href="mailto:support@previsite.com"> Contacter le support</a>|{' '}
                    </span>
                    <a
                        href="https://www.la-boite-immo.com/politique-de-gestion-des-donnees-personnelles"
                        target="_blank"
                        rel="noreferrer"
                        className="text-neutral-500 text-[10px] font-normal font-['Montserrat'] leading-3"
                    >
                        Politique de gestion de données personnelles
                    </a>
                </div>
                <div
                    data-couleur="Default"
                    data-logo="La Boîte Immo"
                    className="w-32 h-8 relative overflow-hidden"
                >
                    <img src={lbiHozizontalLogo} alt="logo lbi" />
                </div>
            </div>
        </div>
    );
}

export default Footer;
